import CryptoJS from 'crypto-js'
// import  CryptoJS from 'library/crypto-js/core-3.1.2.min.js'

export default (() => {

	window.callbackMap = new Map();

	const encodeURIObject = function (obj) {
		var result;
		var check = /[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/;

		if (typeof obj === 'string') {
			if (check.test(obj)) {
				result = encodeURIComponent(obj);
			} else {
				result = obj;
			}
		}
		else {
			result = {};
			for (var k in obj) {
				result[k] = null;
				var obj_child = JSON.parse(obj[k]);
				for (var kk in obj_child) {
					if (!check.test(obj_child[kk]))
						continue;

					obj_child[kk] = encodeURIComponent(obj_child[kk]);
				}
				result[k] = obj_child;
			}
		}
		// 결과 반환
		return result;
	}

	const getUserAgent = function () {
		var device = navigator.userAgent.toLowerCase();
		var return_value;
		if (/android/.test(device)) {
			return_value = "android"; // android
		} else if (/ipad|ipod|iphone/.test(device)) {
			return_value = "ios"; //iOS
		} else {
			return_value = "else";
		}
		return return_value;
	}

	const execute = function (extension, method, callback, params___) {
		/* if (process.env.REACT_APP_TEST) {
			callback && callback()
			return
		} */
		var args = [];
		try {
			for (var i = 0; i < arguments.length; i++) {
				args.push(arguments[i]);
			}

			var info = {};
			info["callback"] = "window.pluginCallbak";
			info["extension"] = args.shift()
			info["method"] = args.shift()

			// callback arg skip
			args.shift();
			var params = [];
			//console.log('params__ =' + JSON.stringify(params___));
			while (args.length > 0) {
				params.push(args.shift());
			}
			info["params"] = params;
			var isIssue = false;
			if (params___ !== undefined && params___.isIssue !== undefined) {
				isIssue = params___.isIssue;
			}

			//console.log('isIssue : ' + isIssue);
			//console.log('execute info : ' + JSON.stringify(info));

			if (!(callback === null || typeof callback === 'undefined')) {
				var callbackStr = '';
				if (Array.isArray(callback)) {
					for (var j = 0; j < callback.length; j++) {
						var _callback = callback[j];
						if ((typeof callback) == 'function') {
							callbackStr += callback.toString();
						} else {
							callbackStr += callback;
						}
					}
				} else {
					if ((typeof callback) == 'function') {
						callbackStr = callback.toString();
					} else {
						callbackStr = callback;
					}
				}

				info["callbackId"] = isIssue + "|" + CryptoJS.SHA256((new Date().getTime()) + callbackStr).toString();
				// info["callbackId"] = isIssue + "|" + (new Date().getTime() + callbackStr).toString();
				//console.log('callbackId : ' + info["callbackId"]);
				window.callbackMap.set(info["callbackId"], callback);
			}

			var json = encodeURIComponent(JSON.stringify(info))
			// alert(json)

	        var webview = window.WEBVIEW;
			if (getUserAgent() === "ios" && webview) {
				alert("lf://" + json)
			} else {
				window.android.setMessage(json)
			}
		} catch (e) {
			for (var k = 0; k < arguments.length; k++) {
				args.push(arguments[k]);
			}
		}
	}

	window.pluginCallbak = function (data) {

		var jsonObj;
		if (typeof data === 'object') {
			jsonObj = data;
			data = JSON.stringify(data);
		} else {
			jsonObj = JSON.parse(data);
		}

		var callbackId = jsonObj.callbackId;
		//console.log('callbackId : ' + callbackId);
		var callback = window.callbackMap.get(callbackId);

		if (typeof callback === undefined || callback === null || callback === "") {
			return;
		}

		if (!callbackId.startsWith('true')) {
			//console.log('callbackMap.delete : ' + callbackId);
			window.callbackMap.delete(callbackId);
		}

		if (Array.isArray(callback)) {
			for (var i = 0; i < callback.length; i++) {
				var _callback = callback[i];
				if (typeof _callback === undefined || _callback === null || _callback === "") {
					continue;
				}

				if ((typeof _callback) == 'function') {
					_callback(data);
				} else {
					eval(_callback + "('" + data + "')");
				}
			}
		} else {
			if (typeof callback === 'function') {
				callback(data);
			} else if (typeof callback !== "undefined") {
				eval(callback + "('" + data + "')");
			}
		}
	}

	const vibrate = (style) => {
		let length
		switch (style) {
			case "light":
				length = "30"
				break
			case "medium":
				length = "50"
				break
			case "heavy":
				length = "100"
				break
			case "rigid":
				length = "80"
				break
			case "soft":
				length = "20"
				break
			default:
				style = "rigid"
				length = "10"
				break
		}
		execute("AppManager", "vibrator", undefined, {
			style: style,
			length: length
		})
	}

	return {
		encodeURIObject: encodeURIObject,
		getUserAgent: getUserAgent,
		execute: execute,
		vibrate: vibrate,
		pluginCallbak: window.pluginCallbak
	};
})();


/*

	 * 텍스트 공유하기
	 * shareText 	: string	/ 공유 테스트
	 * shareTitle	: string	/ Android 공유 타이틀 (default : 공유하기)
	 * callBack		: function	/ 콜백 함수
	

		rgs.text = shareText;
	
		args.title = shareTitle;
	

	Native.execute("AppManager", "share", callBack, args);
};


  * 공유하기
  * shareType 	: string	/ 공유 데이터 타입 (url, text, hex, base64)
  * shareData 	: string	/ 공유 데이터
  * shareFileName: string	/ 공유 데이터의 파일 명
  * shareTitle	: string	/ 공유 타이틀 (default : 모니 공유하기)
  * callBack		: function	/ 콜백 함수

	var args = {
		type : shareType,
		data : shareData,
		filename : shareFileName,
		title : shareTitle
	};

	Native.execute("AppManager", "sharePlus", callBack, args);

	// 클립보드 복사
	args = {
		"text" : text,
		"toast" : "" + toastMsg
	};
	lenket.plugin.core.execute("Util", "copyClipboard", callBack, args);


	// 사파리, 또는 다른 앱
	Native.execute("AppManager", "openScheme", () => { }, {
		url: url
	})

	// 웹뷰
	Native.execute("Popup", "openPopup", callback, {
		view_id: id,
		url: url,
		title: title
	})
};
*/